/**
 * Created by toomasp on 31.08.2015.
 */

require('./tooltip.css');

export let tooltip:any[] = [()=> {
    function getTooltipClass(element) {
        if (element.hasClass("js-tooltip-orange")) {
            return "ui-tooltip-orange"
        } else if (element.hasClass("js-tooltip-magenta")) {
            return "ui-tooltip-magenta"
        } else if (element.hasClass("js-tooltip-white")) {
            return "ui-tooltip-white"
        }
        return "";
    }

    class TooltipDirective {
        restrict = 'A';

        link(scope, element) {
            element = $(element);
            element.tooltip({
                items: "[data-tooltip]",
                show: {
                    effect: "fadeIn",
                    delay: 100,
                    duration: 0
                },
                hide: {
                    effect: "fadeOut",
                    delay: 100,
                    duration: 0
                },
                position: {
                    my: "left bottom-10",
                    at: "left top",
                    collision: "flip",
                    using: function (position, feedback) {
                        $(this).css(position);
                        $("<div>")
                            .addClass("ui-tooltip-arrow")
                            .addClass(feedback.vertical)
                            .addClass(feedback.horizontal)
                            .appendTo($(this));
                    }
                },
                content: function () {
                    var element = $(this);
                    var val = element.attr("data-tooltip");
                    if (val.indexOf('#') == 0) {
                        return $(val).html();
                    }
                    return val;
                }
            });

            var tooltipClass = getTooltipClass(element);
            if (tooltipClass) {
                element.tooltip({
                    tooltipClass: tooltipClass
                });
            }
        }
    }

    return new TooltipDirective();
}];



// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/tooltip.directive.ts